import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=logged out
  const [boot, setBoot] = useState(null);

  const loadMe = async () => {
    const t = localStorage.getItem("indigo_token");
    if (!t) {
      setUser(null);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      loadBootstrap();
    } catch {
      localStorage.removeItem("indigo_token");
      setUser(null);
    }
  };

  const loadBootstrap = async () => {
    try {
      const { data } = await api.get("/bootstrap");
      setBoot(data);
    } catch {}
  };

  useEffect(() => {
    loadMe();
  }, []);

  const applyLogin = (data) => {
    localStorage.setItem("indigo_token", data.token);
    setUser(data.user);
    loadBootstrap();
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    applyLogin(data);
    return data;
  };

  const loginDemo = async (email) => {
    const { data } = await api.post("/auth/login", { email, password: "demo123" });
    applyLogin(data);
    return data;
  };

  const loginWithToken = (data) => applyLogin(data);

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    localStorage.removeItem("indigo_token");
    setUser(null);
    setBoot(null);
  };

  return (
    <AuthContext.Provider value={{ user, boot, login, loginDemo, loginWithToken, logout, refreshBoot: loadBootstrap }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
